import React from 'react';
import ImageCard from '../ImageCard/ImageCard';

const Photos = () => (
    <ImageCard
        imageType="photo"
        label="photos"
        words={['photos', 'wallpapers', 'stock images']}
    />
);

export default Photos;
